import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
// import { FormDataService } from "../../branches-form-data.service";
import { environment } from "src/environments/environment";
import { FeedbackPreviewModel } from "common/models/page-models/feedback-preview/feedback-preview-data-model";
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
    providedIn: 'root'
})
export class FeedbackPreviewDataService extends FormDataService<FeedbackPreviewModel> {
    constructor(http: SmApiService, protected override  ss: SystemService) {
        super(API_URL.feedbackGrid, http, ss);
    }

     getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.previewFeedback,
            method: API_METHODS.post
        }
        return edit;
    }

     override getUpdatePayload(data) {
        let payload;
        payload = {
            id: data.id,
            
        }
        return payload;
    }

    createInstance(): FeedbackPreviewModel {
        return new FeedbackPreviewModel();
    }

    
     override getUpdateUrl() {
        return '';
    }

}